import Vue from 'vue'
import VueRouter from 'vue-router'
import JobList from '../views/JobList.vue'
import JobDetails from '../views/JobDetails.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'job-list',
    component: JobList
  },
  {
    path: '/:slug',
    name: 'job-details',
    component: JobDetails
  }
]

const router = new VueRouter({
  routes
})

export default router
